<template>
    <AppBox class="f-h f-w">
        <div class="error-404">
            <div class="error-code">
                <slot name="errorCode"></slot>
            </div>
            <div class="error-message">
                <slot name="errorMessage"></slot>
            </div>
            <div v-if="showReturnToHomepage" class="return-to-homepage">
                <RouterLink :to="{ name: 'Home' }">
                    {{ $t('lang_404.RETURN_TO_HOMEPAGE') }}
                </RouterLink>
            </div>
        </div>
    </AppBox>
</template>

<script>
import AppBox from '@fifa-bsm/bo-frontend-shared/components/AppBox/AppBox';
import VueTypes from 'vue-types';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'AppErrorPage',
    components: { AppBox },
    props: {
        showReturnToHomepage: VueTypes.bool.def(true),
    },

    data() {
        return {
            homeRoute: { name: 'Home' },
        };
    },
});
</script>

<style lang="scss" scoped>
@use '@/app/styles/globals';

.error-page {
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .error-code {
        @include globals.primary-font(72px);

        font-weight: bold;
    }

    .error-message {
        @include globals.primary-font(32px);
    }

    .return-to-homepage {
        @include globals.primary-font(18px);

        margin-top: 10px;
    }
}
</style>
